import React, { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import Spinner from '../Components/Spinner';
import shinelogo from './images/shinelogo.svg';
import {loginUser} from '../config/api';
const Login = () => {

  const [loader, setLoader] = useState('none');
  const [values, setValues] = useState({
    email: '',
    password: '',
  });

  const toastOptions = {
    position: 'top-right',
    autoClose: 8000,
    pauseOnHover: true,
    draggable: true,
    theme: 'dark',
  };

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleValidation = () => {
    const { email, password } = values;
    if (password === '') {
      toast.error('Password is required', toastOptions);
      return false;
    } else if (email === '') {
      toast.error('Email and Password are required', toastOptions);
      return false;
    }
    return true;
  };

  const PostData = async (event) => {
    event.preventDefault();

    const { email, password } = values;

    const request_login_options = { email, password };

    if (handleValidation()) {
      setLoader('flex');
      const response = await loginUser(request_login_options);
     
      console.log(response);
    
      if (response?.response?.status === 200) {
        toast.success(response?.response?.data?.message, toastOptions);
        setLoader('none');
      }
      else {
        toast.error(response?.response?.data?.error, toastOptions);
        setLoader('none');
      }
      
    }
  };

  return (
    <>
      <div className="login_form_section">
        <div className="form_container_for_login">
          <form method="POST" className="login_u_form" onSubmit={PostData}>
            <div className="brand">
              <img src={shinelogo} alt="logo" />
            </div>
            <input
              type="text"
              placeholder="Enter your Email"
              name="email"
              onChange={(e) => handleChange(e)}
            />
            <input
              type="Password"
              placeholder="Password"
              name="password"
              onChange={(e) => handleChange(e)}
            />
            <button className="login_form_button" type="submit">
              Login
              <Spinner id="login_loder" style={loader} />
            </button>
            <span className="lower_title_login">
              Don't have an account ?
              <HashLink to={'/register'}>Register</HashLink>
            </span>
          </form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default Login;
